document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("hcp-modal");
  const trigger = document.querySelector(".hcp-link-auth");
  const close = document.querySelector(".hcp-modal-close");
  const form = document.getElementById("hcp-consent-form");
  const disagreeBtn = document.querySelector(".disagree-btn");

  if (trigger) {
        trigger.addEventListener("click", function (e) {
            e.preventDefault();
            modal.style.display = "block";
        });

        close.addEventListener("click", function () {
            modal.style.display = "none";
        });

        disagreeBtn.addEventListener("click", function () {
            modal.style.display = "none";
        });

        form.addEventListener("submit", function (e) {
            e.preventDefault();

            const checkboxes = form.querySelectorAll('input[type="checkbox"]:checked');
            if (checkboxes.length < 1) {
            alert("Пожалуйста, поставьте галочку, чтобы продолжить.");
            return;
            }

            modal.style.display = "none";
            window.location.href = '/Форма-анкеты-hcp';
        });

        // close modal if clicked outside
        window.addEventListener("click", function (e) {
            if (e.target == modal) {
            modal.style.display = "none";
            }
        });
    }

  const quizForm = document.getElementById("quiz-form");

  if(quizForm) {
    const errorModal = document.getElementById("errorModal");
    const retakeBtn = document.getElementById("retakeBtn");
    const cancelBtn = document.getElementById("cancelBtn");

    quizForm.addEventListener("submit", function (e) {
        e.preventDefault();

        const answers = {
        q1: 'c',
        q2: 'd',
        q3: 'c'
        };

        let allAnswered = true;
        let allCorrect = true;

        for (const [key, correctValue] of Object.entries(answers)) {
        const selected = document.querySelector(`input[name="${key}"]:checked`);
        if (!selected) {
            allAnswered = false;
            break;
        }
        if (selected.value !== correctValue) {
            allCorrect = false;
        }
        }

        if (!allAnswered) {
        alert("Пожалуйста, ответьте на все вопросы.");
        return;
        }

        if (allCorrect) {
        window.location.href = "/informaciya-po-bezopasnosti-dlya-sotrudnikov-zdravookhraneniya";
        } else {
        if (errorModal) {
            errorModal.style.display = "flex";
        }
        }
    });

    if (retakeBtn) {
        retakeBtn.addEventListener("click", function () {
        quizForm.reset();
        if (errorModal) errorModal.style.display = "none";
        });
    }

    if (cancelBtn) {
        cancelBtn.addEventListener("click", function () {
        if (errorModal) errorModal.style.display = "none";
        window.location.href = '/farmakonadzor';
        });
    }
  }

  const currentPath = window.location.pathname;
  const expectedFormReferrer = window.location.origin + "/farmakonadzor";
  if (currentPath === "/forma-ankety-hcp") {
    const referrer = document.referrer;
    if (!referrer || !referrer.startsWith(expectedFormReferrer)) {
      window.location.href = "/farmakonadzor";
    }
  }

  const expectedFileReferrer = window.location.origin + "/forma-ankety-hcp";

  if (currentPath === "/informaciya-po-bezopasnosti-dlya-sotrudnikov-zdravookhraneniya") {
    const referrerSecond = document.referrer;
    if (!referrerSecond || !referrer.startsWith(expectedFileReferrer)) {
      window.location.href = "/farmakonadzor";
    }
  }
});

document.addEventListener("DOMContentLoaded", function() {
  const decodedPath = decodeURIComponent(window.location.pathname);

  if (decodedPath === "/russia/Продукция/список-продуктов") {

    const pageChildren = Array.from(document.body.children);
    pageChildren.forEach(el => {
      if (el.tagName !== "SCRIPT") {
        el.style.display = "none";
      }
    });

    // Disable scrolling while popup is visible
    document.body.style.overflow = "hidden";

    const popup = document.createElement("div");
    popup.id = "new-hcp-popup";
    Object.assign(popup.style, {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0,0,0,0.6)",
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-start",
      zIndex: "999999",
      padding: "10px",
      paddingTop: "40px"
    });

    popup.innerHTML = `
      <div style="
        background:#fff;
        padding:20px;
        border-radius:8px;
        width: 100%;
        max-width: 500px;
        box-sizing: border-box;
        text-align: center;
        box-shadow:0 4px 10px rgba(0,0,0,0.3);
      ">
        <p style="font-size:20px; font-weight:bold; margin-bottom:20px; color: #6900ef;">
          Данная информация предназначена только для медицинских и фармацевтических работников.
        </p>

        <p style="font-size:16px; margin-bottom:16px;">
          Вы являетесь медицинским работником?
        </p>
        <button id="new-hcp-yes" style="
          margin:5px; padding:10px 20px;
          background:#6900ef; color:#fff;
          border:none; border-radius:20px;
          cursor:pointer; font-size:16px; width:"75px"
        ">
          Да
        </button>
        <button id="new-hcp-no" style="
          margin:5px; padding:10px 20px;
          background:#6900ef; color:#fff;
          border:none; border-radius:20px;
          cursor:pointer; font-size:16px;
        ">
          Нет
        </button>
      </div>
    `;

    document.body.appendChild(popup);

    document.getElementById("new-hcp-yes").addEventListener("click", function() {
      popup.remove();
      document.body.style.overflow = "";
      pageChildren.forEach(el => {
        if (el.tagName !== "SCRIPT") {
          el.style.display = "";
        }
      });
    });

    document.getElementById("new-hcp-no").addEventListener("click", function() {
      window.location.href = "/";
    });
  }
});
